<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createCalendar" (change)="createCalendarChange()" (submit)="createCalendarSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"ACADEMIC_CALENDAR_CREATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/academics/academic-calendar"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">User Status</label>
                                <select class="form-control custom-select" readonly disabled>
                                    <option value="">Select</option>
                                    <option value="Activated" selected>Activated</option>
                                </select>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EFFECTIVE_DATE_FROM" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="effectiveDateFrom">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCalendar.controls.effectiveDateFrom.touched && createCalendar.controls.effectiveDateFrom.invalid && createCalendar.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EFFECTIVE_DATE_TO" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="effectiveDateTo">
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"TYPE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="type">
                                    <option value="" >{{"SELECT" | translate | titlecase }}</option>
                                    <!-- <option value="H">{{"H" | translate | titlecase }}</option>
                                    <option value="O">{{"O" | translate | titlecase }}</option> -->
                                    <option *ngFor="let res of types" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.cdayNameAr : res.cdayNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCalendar.controls.type.touched && createCalendar.controls.type.invalid && createCalendar.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"REPEATS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="repeats">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{"YES" | translate | titlecase }}</option>
                                    <option value="NO">{{"NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCalendar.controls.repeats.touched && createCalendar.controls.repeats.invalid && createCalendar.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"FREQUENCY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="frequency">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="Annual">{{"ANNUAL" | translate | titlecase }}</option>
                                    <option value="Monthly">{{"MONThy" | translate | titlecase }}</option>
                                    <option value="Weekly">{{"WEEKLY" | translate | titlecase }}</option>
                                    <option value="Once">{{"ONCE" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCalendar.controls.frequency.touched && createCalendar.controls.frequency.invalid && createCalendar.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="remarks">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCalendar.controls.remarks.touched && createCalendar.controls.remarks.invalid && createCalendar.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ACTIVE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="active">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{"YES" | translate | titlecase }}</option>
                                    <option value="NO">{{"NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCalendar.controls.active.touched && createCalendar.controls.active.invalid && createCalendar.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>